import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';

import * as http from 'utils/http';
import { login } from 'actions/auth';
import { useGoogleLogin } from '@react-oauth/google';
import { ReactComponent as GoogleIcon } from 'assets/icons/google-color.svg';

import { Modal } from '@ontruck/orc';

import config from 'config';
import styled from 'styled-components';

const actionCreators = {
  login,
};

const LoginWrapper = styled.div`
  position: relative;
`;

const LoginDiv = styled.div`
  display: flex;
  justify-content: center;
  border: 1px solid lightgray;
  gap: 10px;
  padding: 10px 0;
  cursor: pointer;
  svg {
    width: 20px;
    height: 20px;
  }
`;

const LoginContainer = ({ login, history: { replace }, location: { search } }) => {
  const redirectFunction = useCallback(() => {
    const { redirect: redirectUrl } = queryString.parse(search);
    replace(redirectUrl || config.BASE_ROUTE);
  }, [replace, search]);

  const handleLogin = useCallback(
    (response, { access_token }) => {
      const user = {
        name: response.given_name,
        email: response.email,
        avatar: response.picture,
      };
      login(access_token, user, null, redirectFunction);
    },
    [login, redirectFunction]
  );

  const fetchUserData = useGoogleLogin({
    onSuccess: async (tokenObj) => {
      const res = await http.rawGet(
        `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenObj.access_token}`,
        null,
        {
          Authorization: `Bearer ${tokenObj.access_token}`,
          Accept: 'application/json',
        }
      );
      handleLogin(res, tokenObj);
    },
  });

  return (
    <Modal show={true} size="S" headerComponent="You must login to continue" allowClose={false}>
      <LoginWrapper data-e2e="google_login_wrapper">
        <LoginDiv role="login" onClick={fetchUserData}>
          <GoogleIcon /> Login with Google
        </LoginDiv>
      </LoginWrapper>
    </Modal>
  );
};

export default connect(null, actionCreators)(LoginContainer);
